import React, { useEffect } from "react";

const MobileMenu = () => {
  const handleSubMenuToggle = (subMenu) => {
    if (subMenu) {
      subMenu.classList.toggle("active");
      subMenu.style.display = subMenu.style.display === "block" ? "none" : "block";
    }
  };

  const handleMenuItemToggle = (e) => {
    const toggleButton = e.currentTarget;

    // Close other active toggles and submenus in the same UL
    const parentUL = toggleButton.closest("ul");
    if (parentUL) {
      parentUL.querySelectorAll(".xb-menu-toggle.active").forEach((toggle) => {
        if (toggle !== toggleButton) {
          toggle.classList.remove("active");
          const menuItem = toggle.closest(".menu-item");
          const subMenu = menuItem?.querySelector(".sub-menu");
          handleSubMenuToggle(subMenu);
        }
      });
    }

    toggleButton.classList.toggle("active");
    const menuItem = toggleButton.closest(".menu-item");
    const subMenu = menuItem?.querySelector(".sub-menu");
    handleSubMenuToggle(subMenu);
  };

  const handleMenuItemClick = (e) => {
    const target = e.target;

    if (target.closest("a")?.getAttribute("href") === "#" && !target.classList.contains("xb-menu-toggle")) {
      e.preventDefault();

      const menuToggle = target.closest("a")?.querySelector(".xb-menu-toggle");
      if (menuToggle) {
        handleMenuItemToggle({ currentTarget: menuToggle });
      }
    }
  };

  const handleMobileMenuToggle = (e) => {
    e.currentTarget.classList.toggle("active");
    const headerMenu = document.querySelector(".xb-header-menu");
    if (headerMenu) {
      headerMenu.classList.toggle("active");
    }
  };

  const handleMenuClose = (e) => {
    e.currentTarget.classList.remove("active");
    document.querySelector(".xb-header-menu")?.classList.remove("active");
  };

  const cloneMobile2 = () =>{
    const mobileMenu2 = document.querySelectorAll(".clone .container .header-bar-mobile .xb-nav-mobile");
      if (mobileMenu2) {

        mobileMenu2.forEach(element => {
            element.addEventListener("click", handleMobileMenuToggle);  
        });
  
      }
  }

  useEffect(() => {
    const addToggleToMenuItems = (selector) => {
      const menuItems = document.querySelectorAll(selector);
      menuItems.forEach((item) => {
        if (!item.querySelector(".xb-menu-toggle")) { // Prevent adding multiple toggles
          item.insertAdjacentHTML("beforeend", '<span class="xb-menu-toggle"></span>');
        }
      });
    };

    addToggleToMenuItems(".xb-nav-hidden li.menu-item-has-children > a");
    addToggleToMenuItems(".xb-header-menu li.menu-item-has-children");
    addToggleToMenuItems(".xb-menu-primary li.menu-item-has-children");

    const menuToggles = document.querySelectorAll(".xb-menu-toggle");
    menuToggles.forEach((toggle) => toggle.addEventListener("click", handleMenuItemToggle));

    const menuItemsWithChildren = document.querySelectorAll(".xb-nav-hidden li.menu-item-has-children > a");
    menuItemsWithChildren.forEach((item) => item.addEventListener("click", handleMenuItemClick));

    const mobileMenu = document.querySelectorAll(".xb-nav-mobile");
    
    const menuClose = document.querySelector(".xb-menu-close");
    const menuBackdrop = document.querySelector(".xb-header-menu-backdrop");

    if (mobileMenu) {
      mobileMenu.forEach(element => {
          element.addEventListener("click", handleMobileMenuToggle);  
      });
      const anchorinoverlay = document.querySelectorAll('.xb-header-nav ul li a')
      anchorinoverlay.forEach(element => {
        element.addEventListener('click', handleMobileMenuToggle);
      });
      cloneMobile2();
    }
   
    
    if (menuClose) {
      menuClose.addEventListener("click", handleMenuClose);
    }
    if (menuBackdrop) {
      menuBackdrop.addEventListener("click", handleMenuClose);
    }
   
    return () => {
      menuToggles.forEach((toggle) => toggle.removeEventListener("click", handleMenuItemToggle));
      menuItemsWithChildren.forEach((item) => item.removeEventListener("click", handleMenuItemClick));
      if (mobileMenu) {
        mobileMenu.forEach(element => {
          element.removeEventListener("click", handleMobileMenuToggle);  
      });
      }
      if (menuClose) {
        menuClose.removeEventListener("click", handleMenuClose);
      }
      if (menuBackdrop) {
        menuBackdrop.removeEventListener("click", handleMenuClose);
      }
      
    };
    
  }, []);



  return null; // This component doesn't render anything
};

export default MobileMenu;
